{
  "auth": {
    "onboarding": {
      "foreign": {
        "prompt": "Saisissez vos informations professionnelles.",
        "fullName": "Nom complet",
        "specialty": "Spécialité",
        "specialtyPlaceholder": "ex. : cardiologie",
        "specialtyChoose": "Choisissez votre spécialité",
        "specialtyGroupSpecialty": "Spécialités",
        "specialtyGroupSubspecialty": "Surspécialités",
        "specialtyOther": "Autre (absente de la liste)",
        "specialtyOtherLabel": "Votre spécialité",
        "specialtyUnknown": "La spécialité choisie ne figure pas dans la liste. Veuillez refaire votre choix.",
        "degree": "Diplôme",
        "degreePlaceholder": "ex. : MD ou MBChB",
        "country": "Pays de délivrance de votre autorisation d’exercer",
        "countryPlaceholder": "Choisissez un pays",
        "city": "Ville",
        "license": "N° d’autorisation d’exercer (facultatif)",
        "licenseHint": "Le numéro délivré par votre pays.",
        "notice": "Ces informations sont enregistrées sans vérification, et votre profil sera affiché comme « Non vérifié ».",
        "incomplete": "Saisissez votre nom, votre spécialité, votre diplôme, votre pays et votre ville.",
        "licenseTaken": "Ce numéro d’autorisation d’exercer est déjà associé à un autre compte.",
        "notAllowed": "Ce parcours est réservé aux numéros de téléphone hors d’Iran. Veuillez saisir votre numéro d’inscription à l’Ordre des médecins.",
        "unverified": "Non vérifié"
      }
    }
  }
}
